import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags'; 
import { Link } from 'react-router-dom'; // Added Meta Tag npm Package
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, UncontrolledTooltip } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import { COMPANY, STAFF, USERS } from 'helpers/url_helper';
import { Config, TOAST_OPTIONS } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

import { Button,  DropdownToggle,  DropdownMenu,  DropdownItem,  ButtonDropdown,} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined
import BounceLoader from 'react-spinners/BounceLoader'

    const Staff = () => {

        toastr.options = TOAST_OPTIONS;

        const [modal_users, setmodal_users] = useState(false);
        const [isEdit, setIsEdit] = useState(false);
        const [usersList, setUsersList] = useState(null);
        const [modules, setModules] = useState(["CMMS"]);
        const [levels, setLevels] = useState(["SYSTEM USER"]);
        const [user, setUser] = useState(null);
        const [isloading, setIsloading] = useState(false)

        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_users = () => {
        setmodal_users(!modal_users);
        removeBodyCss();
        }

        const fetchData = () => {
          setIsloading(true)
          axios.get(STAFF, Config).then((r)=>{ setUsersList(r.data); setIsloading(false) }).catch((e)=>{  console.log(e); setIsloading(false) });
        }
        
        useEffect(() => {
         fetchData();
        },[]);

        const handleAddUser = () => {  
  
            const obj = JSON.parse(localStorage.getItem("authWTUser"));
            const name      = document.getElementsByClassName('uName')[0].value
            const title     = document.getElementsByClassName('uTitle')[0].value
            const phone     = document.getElementsByClassName('uPhone')[0].value
            const email     = document.getElementsByClassName('uEmail')[0].value
            const category  = document.getElementsByClassName('uCategory')[0].value
            const modules   = document.getElementsByClassName('uModules')
            let selectedModules = '';
            for(let i = 0; i < modules.length; i++){
                if(modules[i].checked){
                    selectedModules += modules[i].value+","
                }
                
            }
            
            
            
            if (isEdit) {
                    const data = {
                        "id"    : user.id, 
                        "name"  : name,
                        "title" : title,
                        "phone" : phone,
                        "email" : email,
                        "category" : category,
                        "modules" : selectedModules,
                        "uuId"    : obj.id,
                        "uuName"  : obj.username
                    }
                    setIsloading(true)
                    axios.put(USERS, JSON.stringify(data), Config).then((r)=>{
                        
                      if(r.data.status == '0'){
                          toastr.error(r.data.message); 
                      }else{
                          toastr.success(r.data.message); 
                          fetchData();
                          tog_users();
                      }
                      setIsloading(false)
                    })
                    .catch((e)=>{
                        console.log(e);
                        setIsloading(false)
                    });
            }else{
                    const data = {
                        "name"  : name,
                        "title" : title,
                        "phone" : phone,
                        "email" : email,
                        "category" : category,
                        "modules" : 'CMMS',
                        "uuId"    : obj.id,
                        "uuName"  : obj.username
                    }
                    setIsloading(true)
                    axios.post(STAFF, JSON.stringify(data), Config).then((r)=>{
                      if(r.data.status == '0'){
                          toastr.error(r.data.message); 
                      }else{
                          toastr.success(r.data.message); 
                          fetchData();
                          tog_users();
                      }
                      setIsloading(false)
                    })
                    .catch((e)=>{
                      console.log(e);
                      setIsloading(false)
                    });
            }
            
        }
        
        const handleClickEdit = (row) => {
          tog_users(); 
          setIsEdit(true); 
          setUser( {id : row.id, name : row.name, title : row.title, phone : row.phone, email : row.email, category: row.category, modules: row.modules, active: row.active} )
          
        }

        const handleClickAdd = () => {
          
          tog_users(); 
          setIsEdit(false);
          setUser(null) 
          
        }

        const { SearchBar } = Search;
        const columns = [

        {
          dataField: 'name',
          text: 'Name',
          sort: true
        }
        ,
        {
          dataField: 'phone',
          text: 'Phone',
          sort: true
        },
        {
          dataField: 'email',
          text: 'Email',
          sort: true
        },
        {
            dataField: 'lastLogin',
            text: 'Last Login',
            sort: true
          },
          {
            dataField: 'status',
            text: 'Status',
            sort: true
          },
        {
          dataField: "action",
          isDummyField: true,
          text: "Action",
          formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'id',
          order: 'asc'
        }];
        function actionFormatter(cellContent, row){
          return(
            <>
             <Button
                  type="button"
                  color="info"
                  className="btn-sm btn-rounded"
                  onClick={() => { handleClickEdit(row); }}
                >
                  Details
            </Button>
          </>
          )
        }

        return (
            <>
            <LoadingOverlay
                active={isloading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Maintenance Staff | {COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="HWA" breadcrumbItem="Maintenance Staff" />


                        <Row>


                            <Col lg="12">
                            <Card>
                                <CardBody>
                                <CardTitle className="mb-4">&nbsp;</CardTitle>

                                
                                <Modal
                                  isOpen={modal_users}
                                  toggle={() => {
                                    tog_users();
                                  }}
                                  centered
                                >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit ? 'Edit Staff ': 'Add Staff' }</h5>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setmodal_users(false);
                                      }}
                                      className="close"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                    <Form>
                          
                                    <div className="row mb-4">
                                      <Label
                                        htmlFor="horizontal-email-Input"
                                        className="col-sm-3 col-form-label"
                                      >
                                        Name
                                      </Label>
                                      <Col sm={12}>
                                        <Input
                                          type="text"
                                          className="form-control uName" 
                                          placeholder=""
                                          defaultValue={ user ? user.name : "" }
                                        />
                                      </Col>
                                    </div>
                                    
                                    <div className="row mb-4">
                                      <Label
                                        htmlFor="horizontal-email-Input"
                                        className="col-sm-12 col-form-label"
                                      >
                                        Title/Designation
                                      </Label>
                                      <Col sm={12}>
                                        <Input
                                          type="text"
                                          className="form-control uTitle"
                                          placeholder=""
                                          defaultValue={ user ? user.title : "" }
                                        />
                                      </Col>
                                    </div>
                                    <div className="row mb-4">
                                      <Label
                                        htmlFor="horizontal-email-Input"
                                        className="col-sm-12 col-form-label"
                                      >
                                        Phone
                                      </Label>
                                      <Col sm={12}>
                                        <Input
                                          type="phone"
                                          className="form-control uPhone"
                                          placeholder=""
                                          defaultValue={ user ? user.phone : "" }
                                        />
                                      </Col>
                                    </div>
                                    <div className="row mb-4">
                                      <Label
                                        htmlFor="horizontal-email-Input"
                                        className="col-sm-12 col-form-label"
                                      >
                                        E-mail
                                      </Label>
                                      <Col sm={12}>
                                        <Input
                                          type="email"
                                          className="form-control uEmail"
                                          placeholder=""
                                          defaultValue={ user ? user.email : "" }
                                        />
                                      </Col>
                                    </div>
                                    <div className="row mb-4">
                                      <Label
                                        htmlFor="horizontal-email-Input"
                                        className="col-sm-12 col-form-label"
                                      >
                                        Category
                                      </Label>
                                      <Col sm={12}>
                                      <select className="form-control uCategory">
                                          { user ?  <option value={user.category}>{user.category}</option> : <option>Select</option> }
                                          { levels && (levels.length > 0) && (
                                            levels.map((a,k)=>(
                                              <option key={k} value={a}>{a}</option>
                                            ))
                                          )}
                                        </select>
                                      </Col>
                                    </div>
                      
                                    </Form>
                                  </div>
                                  <div className="modal-footer">
                                    <button
                                      type="button"
                                      onClick={() => {
                                        tog_users();
                                      }}
                                      className="btn btn-danger "
                                      data-dismiss="modal"
                                    >
                                      Close
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-success "
                                      onClick = {()=>{handleAddUser()}}
                                    >
                                      Save...
                                    </button>
                                  </div>
                                </Modal>

                                {usersList && (usersList.length > 0) && (
                                    <>
                                    <ToolkitProvider
                                      keyField="id"
                                      data={ usersList }
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                             
                                            <Row className='mb-5'>
                                                  <Col lg={8} className='mb-2'>
                                                    <div  className="rounded bg-light d-grid gap-2">
                                                      <SearchBar {...toolkitProps.searchProps} className="form-control bg-transparent border-0 searchTm m-0" />
                                                    </div>
                                                  </Col>
                                            
                                                  <Col lg={4}> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn"
                                                        onClick={() => { handleClickAdd() }}
                                                      >
                                                        <i className="mdi mdi-plus me-1" />
                                                        Add staff
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                            <Row>
                                              <Col xl="12">
                                                <div className="table-responsive">
                                            
                                                <BootstrapTable 
                                                  keyField='id' 
                                                  data={ usersList } 
                                                  columns={ columns } 
                                                  striped
                                                  //hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table align-middle table-nowrap table-check" }
                                                    {...toolkitProps.baseProps}
                                                  />
                                            </div>
                                            </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                  </ToolkitProvider>

                                    </>
                                )}
                                {usersList && (usersList.length < 1) && (
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                        </div>
                                        <div>
                                        <h5>No Users Found</h5>
                                        <p className="text-muted">
                                                
                                        </p>
                                        </div>
                                    </div>

                                )}
                                </CardBody>
                            </Card>
                            </Col>
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default Staff;